import { Component } from '@angular/core';
import { ShareButtonsComponent } from './share-buttons.component';

@Component({
  selector: 'eid-share-buttons-desktop',
  templateUrl: './share-buttons.desktop.component.html',
  styleUrls: ['./share-buttons.desktop.component.scss']
})
export class ShareButtonsDesktopComponent extends ShareButtonsComponent {}
